import styled from 'styled-components';
import IndiaSvg from '../../../assets/onboardingNew/homepage/india.svg';

const IndiaIcon = styled(IndiaSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '2.3rem'};
height: ${props => props.height || '1.7rem'};
display: flex;
`;

export default IndiaIcon;
